export const Data_Section = 'Register_Section'
export const Initial_Register = "initialRegister"
export const LogOut = "LogOut";
export const Socket = "Socket";